import { z } from 'zod';
import { DrawingStatusSchema } from './drawing-set.schema';

export const DrawingRevisionSchema = z.object({
  id: z.string().uuid(),
  drawing_set_id: z.string().uuid(),
  knowledge_item_id: z.string().uuid(),
  revision_number: z.number().int(),
  status: DrawingStatusSchema,
  submitted_by: z.string().uuid().nullable(),
  submitted_at: z.string().datetime().nullable(),
  reviewed_by: z.string().uuid().nullable(),
  reviewed_at: z.string().datetime().nullable(),
  review_notes: z.string().nullable(),
  created_at: z.string().datetime(),
  submitted_by_name: z.string().optional(),
  reviewed_by_name: z.string().optional(),
  title: z.string().optional(),
});

export type DrawingRevision = z.infer<typeof DrawingRevisionSchema>;

export const ReviseRequestSchema = z.object({
  review_notes: z.string().min(1, 'Review notes are required'),
});

export type ReviseRequest = z.infer<typeof ReviseRequestSchema>;
